import { useState } from 'react';
import { Link } from 'react-router-dom';
import MovieCard from '@/components/feature/MovieCard';
import { movies } from '@/mocks/movies';

const tabs = [
  { key: 'hot', label: '播放热度', icon: 'ri-fire-line' },
  { key: 'rating', label: '口碑评分', icon: 'ri-star-line' },
  { key: 'new', label: '编辑精选', icon: 'ri-sparkling-line' },
];

export default function HotRecommend() {
  const [tab, setTab] = useState('hot');

  const sorted = [...movies].sort((a, b) => {
    if (tab === 'rating') return b.rating - a.rating;
    if (tab === 'new') return b.updatedAt.localeCompare(a.updatedAt);
    return b.popularity - a.popularity;
  });

  const list = sorted.slice(0, 9);

  return (
    <section className="w-full px-4 md:px-8 mt-12 md:mt-16">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-5">
        <div>
          <div className="flex items-center gap-2">
            <span className="w-1.5 h-5 rounded-full bg-accent-500"></span>
            <h2 className="font-heading text-xl md:text-2xl font-black text-foreground-950">
              热门内容推荐
            </h2>
          </div>
          <p className="mt-1.5 text-xs md:text-sm text-foreground-500">
            结合播放热度、观众评分与编辑精选，挑出此刻最值得看的作品
          </p>
        </div>
        <div className="flex items-center gap-1 bg-background-100 border border-background-200 rounded-full p-1 w-fit">
          {tabs.map((item) => (
            <button
              key={item.key}
              type="button"
              onClick={() => setTab(item.key)}
              className={`px-3.5 py-1.5 rounded-full text-xs font-medium flex items-center gap-1.5 transition-colors whitespace-nowrap cursor-pointer ${
                tab === item.key
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-600 hover:text-primary-600'
              }`}
            >
              <i className={`${item.icon} text-sm`}></i>
              {item.label}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
        {list.map((movie, i) => (
          <MovieCard key={movie.id} movie={movie} rank={tab === 'hot' ? i : undefined} />
        ))}
      </div>

      <div className="mt-6 flex justify-center">
        <Link
          to="/category/movie"
          className="px-6 h-11 inline-flex items-center gap-2 rounded-md border border-background-300 bg-background-50 text-sm font-medium text-foreground-800 hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          进入频道浏览全部
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}